<template>
    <div>
        <div class="tw-flex tw-justify-center tw-pb-5">
            <!-- BACK BUTTON START -->
            <div class="tw-mt-4 tw-mb-5">
                <div class="tw-text-center">
                    <a @click.prevent="backButtonDidClick">
                        <img class="btn-next" :src="asset('/marketing/smb/icon-arrow.svg')" />
                    </a>
                </div>
            </div>
            <!-- BACK BUTTON END -->

            <div class="tw-w-full tw-text-center">
                <h2 class="tw-text-white tw-font-bold">{{ __('purchase.contact_title') }}</h2>
                <div class="tw-w-full md:tw-w-1/2 tw-mx-auto tw-pt-4">
                    <a class="tw-btn tw-block tw-btn-primary" :href="letsConnect">
                        <h5 class="tw-text-white tw-font-bold tw-pt-1 tw-pb-1">{{ __('purchase.fill_form') }}</h5>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { __ } from 'lib/Utilities';


interface Emits {
    (e: 'back-button-did-click'): void;
}

const emit = defineEmits<Emits>();

// Computed properties
const letsConnect = computed(() => {
    if (window.l.locale && window.l.locale === 'fr') {
        return "https://www.venngo.com/fr/lets-connect?i_am_interested_in_learning_about___=WorkPerks";
    }
    return "https://www.venngo.com/lets-connect?hsCtaTracking=c6c6a156-9a10-482f-8895-7bb4fa903cf0%7C707115bd-512c-40cd-923c-eecf103f61af&i_am_interested_in_learning_about___=WorkPerks";
});

// Methods
const backButtonDidClick = () => {
    emit('back-button-did-click');
};
</script>

